import './UsersPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { AsyncStateNotification } from '@ui/notifications';
import { createAsyncSelectors } from '@lib/selectors';
import React from 'react';
import { ShardSearchEntryDetails } from '@sonar-software/sonar-admin';
import { UsersTable } from './UsersTable';

const patchUserSelectors = createAsyncSelectors((state) => state.core.users.byId.patch);

const postSendResetPasswordLinkSelectors = createAsyncSelectors(
	(state) => state.admin.users.byId.links.passwordReset.send.post
);

const postSendInvitationLinkSelectors = createAsyncSelectors(
	(state) => state.admin.users.byId.links.invitation.send.post
);

export interface UsersPanelProps {
	id?: string;
	searchDetails?: ShardSearchEntryDetails;
}

export const UsersPanel: React.FC<UsersPanelProps> = (props) => {
	const { searchDetails } = props;

	return (
		<div className='admin-users-panel'>
			<UsersTable searchDetails={ searchDetails } />
			<AsyncStateNotification
				errored={ ADMIN_DASHBOARD_COPY.UPDATE_USER_FAILED }
				failed={ ADMIN_DASHBOARD_COPY.UPDATE_USER_FAILED }
				stateSelector={ patchUserSelectors.state } />
			<AsyncStateNotification
				errored={ ADMIN_DASHBOARD_COPY.SEND_PASSWORD_RESET_FAILED }
				failed={ ADMIN_DASHBOARD_COPY.SEND_PASSWORD_RESET_FAILED }
				received={ ADMIN_DASHBOARD_COPY.SEND_PASSWORD_RESET_SUCCESS }
				stateSelector={ postSendResetPasswordLinkSelectors.state } />
			<AsyncStateNotification
				errored={ ADMIN_DASHBOARD_COPY.RESEND_USER_INVITE_FAILED }
				failed={ ADMIN_DASHBOARD_COPY.RESEND_USER_INVITE_FAILED }
				received={ ADMIN_DASHBOARD_COPY.RESEND_USER_INVITE_SUCCESS }
				stateSelector={ postSendInvitationLinkSelectors.state } />
		</div>
	);
};
